import { Component, Input, OnInit, ChangeDetectorRef, ElementRef, SimpleChanges, OnChanges, Output, EventEmitter, HostListener, AfterViewInit } from '@angular/core';
import { Book } from '../../shared/models/book';

@Component({
  selector: 'app-pdf-fullView',
  templateUrl: './pdf-fullView.component.html',
  styleUrls: ['./pdf-fullView.component.css']
})
export class PdfFullViewComponent implements OnInit {

  @Input() bookObj: Book;
  @Input() pdfPath;
  @Input() bookDataObj: any;
  @Input() originalCanvasWidth: number;
  @Input() originalCanvasHeight: number;
  @Input() currentPageNumber: any;

  @Output() callBackFromPdfFullview: EventEmitter<any> = new EventEmitter<string>();

  public showFullViewHeader: boolean = false;
  public fullViewPageNumber: any = 1;
  public fullViewSliderCpos: number = 1;
  public PDF_DOC;
  slider;
  sliderWidth;
  sliderOffsetX;
  sliderOffsetY;
  canvas;
  ctx;
  canvasWidth;
  canvasHeight;
  canvasLineJson = [];
  num;
  canvaspdfHeight;
  canvaspdfWidth;

  constructor(private ele: ElementRef) { }

  ngOnInit() {
    //Initializing the loader
    this.ele.nativeElement.querySelector('.pdfFullViewContainer .lds-roller').style.display = 'block';
    this.fullViewPageNumber = this.currentPageNumber;
    this.fullViewSliderCpos = this.fullViewPageNumber;

    if (this.bookDataObj[this.fullViewPageNumber].drawing && this.bookDataObj[this.fullViewPageNumber].drawing.length > 0) {
      this.canvasLineJson = this.bookDataObj[this.fullViewPageNumber].drawing;
    }

  }

  @HostListener('mousemove', ['$event'])
  onMousemove(event: MouseEvent) {
    // this.findPosition('move', event);
  }

  ngAfterViewInit() {

    this.showFullViewHeader = true;
    document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '100%';

    var self = this;
    setTimeout(function () {
      if (document.getElementsByClassName('fullViewHeaderToolBar')[0]) {
        self.showFullViewHeader = false;
        document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '0%';
      }
    }, 800);

  }

  myMethod(evt) {
    let pdfOverFlow = document.getElementsByClassName("ng2-pdf-viewer-container");
    pdfOverFlow[0].scrollTop = evt.srcElement.scrollTop;
  }

  onFullViewHeaderMouseEnter() {
    this.showFullViewHeader = true;
    document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '100%';
  }

  onFullViewHeaderMouseLeave() {
    this.showFullViewHeader = false;
    document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '0%';
  }

  closePdfFullView() {
    this.showFullViewHeader = false;
    this.callBackFromPdfFullview.emit('closePdfFullView');
  }

  onPrevious() {
    if (this.ctx) this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    this.fullViewPageNumber = this.fullViewPageNumber - 1;
    this.fullViewSliderCpos = this.fullViewPageNumber;
    this.updateFullViewDrawing();
  }

  callBackFn(pdf) {
    this.PDF_DOC = pdf;
    this.bookObj.pageCount = pdf.numPages;
    //this.bookObj.EBEComp = this;
    // do anything with "pdf"

    //Hiding the loader
    this.ele.nativeElement.querySelector('.pdfFullViewContainer .lds-roller').style.display = 'none';

    setTimeout(() => {
      ;
      this.canvas = document.getElementById('fullViewPdfCanvasDrawing');
      let currentCanvasDim = document.getElementsByClassName('canvasWrapper');
      this.canvaspdfHeight = currentCanvasDim[0].clientHeight + "px";
      this.canvaspdfWidth = currentCanvasDim[0].clientWidth + "px";
      this.canvas.height = currentCanvasDim[0].clientHeight;
      this.canvas.width = currentCanvasDim[0].clientWidth;
      this.drawCanvasFromObj();
    }, 100);
  }

  updateSliderData(event) {
    this.slider = document.getElementById("FullViewSlider");

    this.sliderOffsetX = this.slider.getBoundingClientRect().left - document.documentElement.getBoundingClientRect().left;
    this.sliderOffsetY = this.slider.getBoundingClientRect().top - document.documentElement.getBoundingClientRect().top;

    this.sliderWidth = this.slider.offsetWidth - 1;
    var currentMouseXPos = (event.clientX + window.pageXOffset) - this.sliderOffsetX;
    var sliderValAtPos = Math.round(currentMouseXPos / this.sliderWidth * 100);

    if (sliderValAtPos < 1) sliderValAtPos = 1;

    this.fullViewSliderCpos = this.bookObj.pageCount * (sliderValAtPos / 100);
    if (this.fullViewSliderCpos > this.bookObj.pageCount) this.fullViewSliderCpos = this.bookObj.pageCount;
    this.fullViewSliderCpos = Math.round(this.fullViewSliderCpos);
  }

  comeOutFromSlider() {
    this.fullViewSliderCpos = this.fullViewPageNumber;
  }

  onNext() {
    if (this.ctx) this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    this.fullViewPageNumber = this.fullViewPageNumber + 1;
    this.fullViewSliderCpos = this.fullViewPageNumber;
    this.updateFullViewDrawing();
  }

  updateFullViewDrawing() {

    if (this.bookDataObj[this.fullViewPageNumber] && this.bookDataObj[this.fullViewPageNumber].drawing && this.bookDataObj[this.fullViewPageNumber].drawing.length > 0) {
      this.canvasLineJson = this.bookDataObj[this.fullViewPageNumber].drawing;
      this.drawCanvasFromObj();
    }

  }

  drawCanvasFromObj() {

    ;

    this.canvas = document.getElementById('fullViewPdfCanvasDrawing');
    this.ctx = this.canvas.getContext("2d");
    this.canvasWidth = this.canvas.width;
    this.canvasHeight = this.canvas.height;
    ;
    if (this.canvasLineJson && this.canvasLineJson.length) {
      for (this.num = 0; this.num < this.canvasLineJson.length; this.num++) {
        if (this.canvasLineJson[this.num].X2 && this.canvasLineJson[this.num].Y2) {
          this.drawLineOnColourChange(this.num);
        }
      }
    }

  }

  drawLineOnColourChange(i1) {
    this.ctx.beginPath();

    this.ctx.moveTo((this.canvasWidth / this.originalCanvasWidth) * (this.canvasLineJson[this.num].X1), (this.canvasHeight / this.originalCanvasHeight) * (this.canvasLineJson[this.num].Y1));
    for (this.num = i1; this.num < this.canvasLineJson.length; this.num++) {
      this.ctx.lineTo((this.canvasWidth / this.originalCanvasWidth) * (this.canvasLineJson[this.num].X2), (this.canvasHeight / this.originalCanvasHeight) * (this.canvasLineJson[this.num].Y2));

      if (this.canvasLineJson[this.num].X2 == undefined && this.canvasLineJson[this.num].Y2 == undefined) {
        this.ctx.strokeStyle = this.canvasLineJson[this.num - 1].color;
        this.ctx.lineWidth = this.canvasLineJson[this.num - 1].thikness;
        this.ctx.globalAlpha = this.canvasLineJson[this.num - 1].opacity;
        this.ctx.stroke();
        this.ctx.closePath();
        return;
      }
    }
    this.ctx.strokeStyle = this.canvasLineJson[this.num - 1].color;
    this.ctx.lineWidth = this.canvasLineJson[this.num - 1].thikness;
    this.ctx.globalAlpha = this.canvasLineJson[this.num - 1].opacity;
    this.ctx.stroke();
    this.ctx.closePath();
  }


}



// WEBPACK FOOTER //
// ./src/app/bookShared/pdf-fullView/pdf-fullView.component.ts